module.exports = __webpack_public_path__ + "static/media/fitinsur-logo.1eba2c58.svg";